import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";
import SEO from "@/components/SEO";
import BreadcrumbSchema from "@/components/BreadcrumbSchema";
import { Tractor, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import bannerImage from "@/assets/store-pet-accessories.jpg";

const AttrezzaturaAgricola = () => {
  const products = [
    {
      name: "Attrezzi manuali",
      description: "Attrezzi di qualità per lavori agricoli e di giardinaggio",
      features: ["Zappe e vanghe", "Rastrelli e forche", "Cesoie e forbici", "Attrezzi professionali"]
    },
    {
      name: "Sistemi di irrigazione",
      description: "Soluzioni complete per l'irrigazione di orti e giardini",
      features: ["Tubi e raccordi", "Irrigatori e spruzzatori", "Impianti goccia a goccia"]
    },
    {
      name: "Recinzioni e reti",
      description: "Materiali per delimitare e proteggere le coltivazioni",
      features: ["Reti metalliche", "Pali e paletti", "Reti ombreggianti", "Reti antigrandine"]
    },
    {
      name: "Accessori per la coltivazione",
      description: "Tutto il necessario per curare le tue colture",
      features: ["Teli pacciamanti", "Tutori e legacci", "Telo da serra", "Vasi e contenitori"]
    }
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Attrezzatura Agricola e Irrigazione - Magione"
        description="Attrezzi manuali per agricoltura, sistemi di irrigazione goccia a goccia, reti metalliche e accessori per coltivazione. A Magione (PG)."
        keywords="attrezzi agricoli magione, irrigazione goccia goccia perugia, reti metalliche umbria, accessori orto trasimeno"
        canonical="/prodotti/attrezzatura-agricola"
        type="product"
      />
      <BreadcrumbSchema items={[
        { name: "Home", url: "/" },
        { name: "Attrezzatura Agricola", url: "/prodotti/attrezzatura-agricola" }
      ]} />
      <Navbar />

      {/* Hero Banner Section */}
      <section className="relative h-[450px] md:h-[500px] overflow-hidden pt-24 md:pt-28">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${bannerImage})` }}
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />

        {/* Content */}
        <div className="relative container mx-auto px-4 h-full flex flex-col justify-start md:justify-center pt-2 md:pt-0">
          <Link to="/#prodotti" className="mb-6 w-fit">
            <Button variant="outline" className="bg-white/10 text-white border-white/30 hover:bg-white/20 backdrop-blur-sm">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Torna ai prodotti
            </Button>
          </Link>

          <div className="max-w-4xl">
            <div className="icon-wrapper mb-6 w-16 h-16 text-white hidden md:flex items-center justify-center">
              <Tractor className="w-12 h-12" />
            </div>
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6 text-white">
              Attrezzatura Agricola
            </h1>
            <p className="text-xl text-white/90 max-w-3xl">
              Attrezzi e accessori per l'agricoltura e il giardinaggio. Prodotti di qualità
              per professionisti e appassionati del verde.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
            {products.map((product, index) => (
              <div
                key={index}
                className="bg-card rounded-2xl p-8 border border-border card-hover"
              >
                <h3 className="text-2xl font-heading font-semibold mb-4">
                  {product.name}
                </h3>
                <p className="text-muted-foreground mb-6">
                  {product.description}
                </p>
                <ul className="space-y-2">
                  {product.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <span className="text-primary mr-2">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary/5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-4">
            Cerchi un attrezzo specifico?
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Vieni a trovarci in negozio per vedere tutta la nostra gamma di prodotti
            e ricevere consigli dal nostro personale esperto.
          </p>
          <Link
            to="/#contatti"
            className="inline-block px-8 py-3 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            Contattaci
          </Link>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </div>
  );
};

export default AttrezzaturaAgricola;
